module.exports = function () {
    return ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'];
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/iana-hashes/lib/get-hashes-browser.js
// module id = 566
// module chunks = 2